// extracted by mini-css-extract-plugin
module.exports = {"helpButton":"HelpButton_helpButton__3sVyG","icon":"HelpButton_icon__I2UMw","text":"HelpButton_text__11QJE"};